import { paragraphRowRole } from './resource_row_paragraph.js';

/**
 * After PATCHing a resource title, align every resource row of `rowTypeName` that
 * shares `resourceId` (duplicate embeds). Updates only the title paragraph so
 * subtitles are preserved.
 */
export function syncResourceRowParagraphsForResource(rowTypeName, resourceId, titleText) {
  const view = typeof window !== 'undefined' ? window.currentTiptapEditor?.view : null;
  if (!view || !titleText || !rowTypeName) return;
  const rid = String(resourceId);
  const { state } = view;
  const { doc, schema } = state;
  const updates = [];

  doc.descendants((node, pos) => {
    if (node.type.name !== rowTypeName) return;
    if (String(node.attrs.resourceId || '') !== rid) return;

    let titleOffset = 0;
    let titleParagraph = null;
    node.forEach((child, offset) => {
      if (child.type.name !== 'paragraph') return;
      if (paragraphRowRole(child) === 'subtitle') return;
      if (!titleParagraph) {
        titleParagraph = child;
        titleOffset = offset;
      }
    });

    if (!titleParagraph) return;
    if ((titleParagraph.textContent || '') === titleText) return;

    const from = pos + 1 + titleOffset;
    const to = from + titleParagraph.nodeSize;
    updates.push({ from, to, attrs: { ...titleParagraph.attrs, psRowRole: 'title' } });
  });

  if (updates.length === 0) return;

  const tr = state.tr;
  updates.sort((a, b) => b.from - a.from);
  updates.forEach(({ from, to, attrs }) => {
    tr.replaceWith(from, to, schema.nodes.paragraph.create(attrs, schema.text(titleText)));
  });
  view.dispatch(tr);
}
